import React, { useState } from 'react';
import { Typography, LoadingButton, Checkbox } from '@one-thd/sui-atomic-components';
import { SweepstakesMarkdown } from '../../../utils/SweepstakesMarkdown';
import { SWEEPSTAKES_OPT_IN_CONTENT } from '../../../../../core/Data/SweepstakesMockData';
import { windowExists } from '../../../../../common/utils/AccountUtils';
import { useFetchSweepstakesAccept } from '../../../../../hooks';
import { RenderGenericError } from '../../SweepstakesUtils';

// Render components
const RenderCheckbox = ({ checked, onChange, text, testId }) => (
  <div className="sui-flex sui-items-center">
    <Checkbox
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      data-testid={testId}
    />
    <Typography variant="body-sm">
      {text}
    </Typography>
  </div>
);

const RenderFooterContent = ({
  termsChecked,
  setTermsChecked,
  associateChecked,
  setAssociateChecked,
  acceptError,
  isLoadingAccept,
  isButtonDisabled,
  handleTakeSurvey,
}) => (
  <div className="sui-space-y-2">
    <RenderCheckbox
      checked={termsChecked}
      onChange={setTermsChecked}
      text={SWEEPSTAKES_OPT_IN_CONTENT.termsText}
      testId="terms-checkbox"
    />
    <RenderCheckbox
      checked={associateChecked}
      onChange={setAssociateChecked}
      text={SWEEPSTAKES_OPT_IN_CONTENT.associateText}
      testId="associate-checkbox"
    />
    {acceptError && (
      <div className="sui-py-3">
        <RenderGenericError
          refresh={handleTakeSurvey}
          testId="sweepstakes-accept-error"
        />
      </div>
    )}
    <LoadingButton
      variant="primary"
      fullWidth
      disabled={isButtonDisabled}
      loading={isLoadingAccept}
      onClick={handleTakeSurvey}
      data-testid="opt-in-take-survey-button"
    >
      {SWEEPSTAKES_OPT_IN_CONTENT.ctaTitle}
    </LoadingButton>
  </div>
);

export const OptInContent = () => {
  const [termsChecked, setTermsChecked] = useState(false);
  const [associateChecked, setAssociateChecked] = useState(false);
  const { isLoadingAccept, acceptError, acceptSweepstakes } = useFetchSweepstakesAccept();

  const handleTakeSurvey = async () => {
    if (termsChecked && associateChecked) {
      const result = await acceptSweepstakes();

      if (result.success && windowExists()) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('loyalty-benefits.sweepstakes-accepted', {
          termsAccepted: termsChecked,
          associateConsent: associateChecked,
        });
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('loyalty-benefits.open-sweepstakes-survey-drawer', {});
      }
    }
  };

  const isButtonDisabled = !termsChecked || !associateChecked || acceptError;

  const content = (
    <div className="sui-space-y-4" data-testid="sweepstakes-opt-in-content">
      <div className="sui-space-y-4">
        <SweepstakesMarkdown markdownText={SWEEPSTAKES_OPT_IN_CONTENT.content} />
      </div>
    </div>
  );

  const footer = (
    <RenderFooterContent
      termsChecked={termsChecked}
      setTermsChecked={setTermsChecked}
      associateChecked={associateChecked}
      setAssociateChecked={setAssociateChecked}
      acceptError={acceptError}
      isLoadingAccept={isLoadingAccept}
      isButtonDisabled={isButtonDisabled}
      handleTakeSurvey={handleTakeSurvey}
    />
  );

  return { content, footer };
};